import React from 'react';

// ── Coquille des pages du TUTEUR ────────────────────────────────────────────
// En-tête et pied de page PROPRES au tuteur, copiés plutôt que partagés.
//
// La règle est nette : aucune page personnelle ne touche un composant du
// parcours public. `Header.jsx` avait reçu un lien conditionnel « si
// propriétaire » — inerte pour les autres, mais c'était quand même une
// modification d'un fichier partagé, et c'est précisément ce genre de petite
// entorse qui a fini par ajouter quatre filtres à la barre publique.
//
// Duplication assumée : une quinzaine de lignes contre la garantie que rien
// dans cet écran ne peut atteindre le quiz de qui que ce soit.

const LIENS = [
  ['/?tuteur', 'Tuteur'],
  ['/?rappel', 'Rappel'],
  ['/?decliner', 'Décliner'],
  ['/?formes', 'Formes'],
  ['/?tableaux', 'Tableaux'],
  ['/?ecrire', 'Écrire'],
  ['/?ecoute', 'Écoute'],
];

export default function Shell({ actif, cursive, toggleCursive, children }) {
  const lien = 'text-xs transition-colors py-3 -my-3';
  return (
    <div className="min-h-screen bg-slate-900 text-white overflow-x-hidden">
      <div className="max-w-xl md:max-w-2xl mx-auto px-4 py-6 min-h-screen flex flex-col">
        <div className="flex items-center gap-3 flex-wrap justify-end">
          {LIENS.map(([href, nom]) => (
            <a key={href} href={href}
               className={`${lien} ${actif === href ? 'text-blue-300' : 'text-slate-500 hover:text-slate-300'}`}>
              {nom}
            </a>
          ))}
          <button
            onClick={toggleCursive}
            lang="ru"
            title="Imprimerie ou cursive"
            className={`text-sm transition-colors py-3 -my-3 ${cursive ? 'text-blue-300' : 'text-slate-500 hover:text-slate-300'}`}
          >
            Аа
          </button>
        </div>
        <div className="flex flex-col gap-8 mt-6 flex-1">{children}</div>
        <footer className="text-center mt-10 text-slate-600 border-t border-slate-800 pt-4 pb-3">
          <a href="/" className="text-xs hover:text-slate-400 transition-colors">Retour au site</a>
        </footer>
      </div>
    </div>
  );
}
